import { render, staticRenderFns } from "./cSelectPatients.vue?vue&type=template&id=a1038592&scoped=true&lang=pug"
import script from "./cSelectPatients.vue?vue&type=script&lang=js"
export * from "./cSelectPatients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1038592",
  null
  
)

export default component.exports